/**
 * Build CSV column specs per tab. For Media Devoted | Created By Ciro Autiero
 */

import { countryKeyToIso2 } from '@trafficpulse/shared';

import type { GenericStatsRow } from '../shared/generic-stats.types';
import { VOLUUM_COLUMNS } from '../shared/constants';

export interface CsvColumnSpec {
  key: string;
  label: string;
  getValue: (row: GenericStatsRow) => string | number;
}

export interface CsvExportContext {
  smswiserCountryId?: number | null;
  /** Workspace country key (e.g. uk, belgium_fr) — used for Country ISO column. */
  countryKey?: string | null;
}

export function buildCsvColumnsForTab(
  tab: string,
  firstColumnKey: string,
  firstColumnLabel: string,
  context?: CsvExportContext,
): CsvColumnSpec[] {
  const first: CsvColumnSpec = {
    key: firstColumnKey,
    label: firstColumnLabel,
    getValue: (row) => row.label ?? row.id ?? '—',
  };

  if (tab === 'phone') {
    const countryId = context?.smswiserCountryId;
    return [
      { key: 'phone', label: 'Phone', getValue: (r) => r.label ?? r._originalPhone?.phone ?? '—' },
      { key: 'sourceId', label: 'Source ID', getValue: (r) => r._originalPhone?.sourceId ?? r.subLabel ?? '—' },
      {
        key: 'country',
        label: 'Country (SMSWiser ID)',
        getValue: () => (countryId != null && Number.isFinite(countryId) ? String(countryId) : ''),
      },
      {
        key: 'countryIso',
        label: 'Country ISO',
        getValue: () => {
          const ck = context?.countryKey?.trim();
          if (!ck) return '';
          return countryKeyToIso2(ck) ?? '';
        },
      },
      {
        key: 'crossSourceFilterNote',
        label: 'Cross-source vs filters',
        getValue: () => '',
      },
      ...VOLUUM_COLUMNS.map((c) => ({
        key: c.key,
        label: c.label,
        getValue: (r: GenericStatsRow) => r.voluum?.[c.key] ?? '',
      })),
    ];
  }

  const rest = VOLUUM_COLUMNS.map((c) => ({
    key: c.key,
    label: c.label,
    getValue: (r: GenericStatsRow) => r.voluum?.[c.key] ?? '',
  }));

  return [first, ...rest];
}
